// extracted by mini-css-extract-plugin
export var cardIcon = "_5b-4";
export var checkboxCard = "_5b-0";
export var checkboxCardSelected = "_5b-3";
export var disabled = "_5b-1";
export var outerBorder = "_5b-2";
export var spacerMedium = "_5b-7";
export var spacerSmall = "_5b-6";
export var spacerXsmall = "_5b-5";